export const ovgStyles = {
	header: {
		backgroundColor: '#F8F8F8',
	},
	sidebar: {
		backgroundColor: '#212121',
		color: 'white',
	},
	button: {
		backgroundColor: '#499d60',
		color: '#fff',
		border: '1px solid #000',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#cca872',
			borderColor: '#000',
		},
	},
	text: {
		color: '#050709',
		buttonLoadingColor: '#336195',
	},
	title: {
		color: '#000000',
	},
	table: {
		headerBackgroundColor: '#6582af',
		headerTextColor: '#081831',
	},
	platformName: {
		name: 'Oak View Group',
	},
	logo: {
		small: {
			src: '/ovg/oak-view-group-icon.svg',
			height: 35,
			width: 35,
		},
		large: {
			src: '/ovg/oak-view-group-full-logo.svg',
			height: 54,
			width: 160,
		},
	},
	favicon: {
		src: '/ovg/oak-view-group-icon.svg',
	},
	socials: {
		instagram: 'https://www.instagram.com/oakviewgroup',
		facebook: 'https://www.facebook.com/oakviewgroup',
		linkedIn: 'https://www.linkedin.com/company/oak-view-group',
		x: 'https://x.com/oakviewgroup',
	},
	siteUrl: 'https://parkovg.com/',
	orgName: 'Oak View Group',
};
